import { render, staticRenderFns } from "./AdvertiseBlock.vue?vue&type=template&id=048a1cae&scoped=true&"
import script from "./AdvertiseBlock.vue?vue&type=script&lang=js&"
export * from "./AdvertiseBlock.vue?vue&type=script&lang=js&"
import style0 from "./AdvertiseBlock.vue?vue&type=style&index=0&id=048a1cae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a1cae",
  null
  
)

export default component.exports